import { createSlice } from "@reduxjs/toolkit";
import { getNotes } from '../reduxApi/NotesReduxApi'

const notesSlice = createSlice({
    name: 'notes',
    initialState: {
        status: 'idel',
        notes: [],
    },
    reducers: {
        deleteNotesAction: (state, action) => {
            const idToDelete = action.payload.id; 
            const index = state.notes.findIndex((item) => item.notes.ROWID === idToDelete);
            if (index !== -1) {
                state.notes.splice(index, 1); 
            }
        },
        updateNotesAction: (state, action) => {
            console.log("action", action.payload)
            const index = state.notes.findIndex((item) => item.notes.ROWID === action.payload.ROWID)
            if (index != -1) {
                state.notes.splice(index, 1, { notes: action.payload })
            }
        },
        addNotesAction: (state, action) => {
            console.log("Adding notes:", action.payload);
            state.notes.unshift({ notes: action.payload });
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getNotes.pending, (state, action) => {
            state.status = 'pending'
        })
            .addCase(getNotes.fulfilled, (state, action) => {
                state.status = 'fulfilled'
                console.log("testing notes Data", action.payload)
                state.notes = action.payload.data.result;
            })
    }
})
export const { deleteNotesAction, updateNotesAction, addNotesAction } = notesSlice.actions
export default notesSlice.reducer